"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesApiImpl = void 0;
const tslib_1 = require("tslib");
const ApiBase_1 = require("./ApiBase");
const NotesRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/NotesRedux"));
const SystemRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/SystemRedux"));
class NotesApiImpl extends ApiBase_1.ApiBase {
    addNote(noteStr, primaryKeyValue, columnId) {
        const note = {
            Value: noteStr,
            PrimaryKeyValue: primaryKeyValue,
            ColumnId: columnId,
            AdaptableId: this.adaptable.api.optionsApi.getAdaptableId(),
            Author: {
                UserName: this.adaptable.api.optionsApi.getUserName(),
            },
            Timestamp: Date.now(),
        };
        this.dispatchAction(NotesRedux.NotesAdd(note));
    }
    editNote(note) {
        note.Timestamp = Date.now();
        this.dispatchAction(NotesRedux.NotesEdit(note));
    }
    updateNoteText(noteStr, note) {
        note.Value = noteStr;
        this.editNote(note);
    }
    deleteNote(note) {
        this.dispatchAction(NotesRedux.NotesDelete(note));
    }
    getNotesState() {
        return this.getAdaptableState().Notes;
    }
    getAllNotes() {
        return this.getNotesState().Notes;
    }
    getCellNotes(config) {
        return NotesRedux.GetNotesSelector(this.getAdaptableState().Notes, config);
    }
    getNoteByUuid(uuid) {
        return this.getAllNotes().find((note) => note.Uuid === uuid);
    }
    showNotes(noteGridCell, editMode) {
        this.dispatchAction(SystemRedux.SystemNotesShow(noteGridCell, editMode));
    }
    hideNote() {
        this.dispatchAction(SystemRedux.SystemNoteHide());
    }
    getOpenNoteGridCell() {
        return SystemRedux.SystemNotesSelector(this.getAdaptableState().System);
    }
    getNotePopupEditMode() {
        return SystemRedux.SystemNotesEditModeSelector(this.getAdaptableState().System);
    }
}
exports.NotesApiImpl = NotesApiImpl;
